// Module
var code = "<div class=\"wizard\">\n    <tpl for=\"stages\">\n        <div class=\"stage {stageCls}\"><div class=\"aligner\"><span class=\"badge\">{#}</span><span class=\"hide-on-phone text\">{title}</span></div></div>\n    </tpl>\n</div>\n";
// Exports
module.exports = code;